import { Stack } from '@mui/material';

import { Card, CardContent, LinearProgress, Typography } from '@occc/ui-design-system';

type SegmentAssignMembershipsCardProps = {
  loading: boolean;
  children: React.ReactNode;
};

export const SegmentAssignMembershipsCard = ({
  loading,
  children,
}: SegmentAssignMembershipsCardProps) => {
  return (
    <Card>
      {loading && <LinearProgress />}
      <CardContent>
        <Stack>
          <Typography variant='body1' mb={3}>
            Assign Memberships to Segment
          </Typography>

          {children}
        </Stack>
      </CardContent>
    </Card>
  );
};
